import { registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import localeEn from '@angular/common/locales/en';
import { APP_INITIALIZER, ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Router } from '@angular/router';
import { buildAngularAuthConfig, UserScope } from '@logto/js';
import * as Sentry from '@sentry/angular';
import { AuthModule } from 'angular-auth-oidc-client';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CallbackComponent } from './core/components/callback/callback.component';
import { MenuItemDisplayValueComponent } from './core/components/menu-item-display-value/menu-item-display-value.component';
import { MenuItemComponent } from './core/components/menu-item/menu-item.component';
import { NotFoundComponent } from './core/components/not-found/not-found.component';
import { ProductSearchDialogComponent } from './core/components/product-search-dialog/product-search-dialog.component';
import { ScannerPanelComponent } from './core/components/scanner-panel/scanner-panel.component';
import { ToolbarComponent } from './core/components/toolbar/toolbar.component';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { DashboardModule } from './features/dashboard/dashboard.module';
import { TimeModule } from './features/time/time.module';
import { AppFormsModule } from './forms/forms.module';
import { MaterialModule } from './material.module';
import { SharedModule } from './shared/shared.module';

registerLocaleData(localeEn, 'en-CA');

@NgModule({
  declarations: [
    AppComponent,
    CallbackComponent,
    MenuItemComponent,
    MenuItemDisplayValueComponent,
    ProductSearchDialogComponent,
    ScannerPanelComponent,
    NotFoundComponent,
    ToolbarComponent,
  ],
  bootstrap: [AppComponent],
  imports: [
    AppFormsModule,
    AppRoutingModule,
    AuthModule.forRoot({
      config: {
        ...buildAngularAuthConfig({
          ...environment.logto,
          scopes: [UserScope.Email, 'user:fitness'],
        }),
        triggerAuthorizationResultEvent: true,
        // Renew (or re-login) slightly before expiry, so a token about to expire isn't sent to the API
        renewTimeBeforeTokenExpiresInSeconds: 30,
      },
    }),
    BrowserAnimationsModule,
    BrowserModule,
    DashboardModule,
    FormsModule,
    MaterialModule,
    ReactiveFormsModule,
    SharedModule,
    TimeModule,
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'en-CA' },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
  ],
})
export class AppModule {}
